import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function redirectLoginReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.SHOULD_REDIRECT:
            return true;
        case AuthActionTypes.RESET_REDIRECT:
            return false;
        default:
            return state;
    }
}
